export default __webpack_public_path__ + "static/media/grid-4.ff80e188.svg";